import Glide from '@glidejs/glide';

export const VideoSlideshow = (function() {
	'use strict';

	let sliders,
		vidyardModalTriggers,
		hash,
		shareButtons;

	function init() {
		sliders = document.querySelectorAll('.pxblock--video-slideshow .slides');
		if (sliders.length > 0){
			initSliders();
		}
		
		vidyardModalTriggers = document.querySelectorAll('[data-vidyard-modal]');
		if(vidyardModalTriggers.length > 0){
			initVideoModals();
		}

		hash = window.location.hash;
		if (hash && hash.startsWith('#video-')) {
			const vidyardID = hash.slice(7);
			openVidyardModal(vidyardID);
		}

		shareButtons = document.querySelectorAll('[data-share-video]');
		if(shareButtons.length > 0){
			initShareButtons();
		}
	}

	function initShareButtons(){
		shareButtons.forEach(btn => {
			btn.addEventListener('click', function(e){
				e.preventDefault();
				const shareVideoID = this.dataset.shareVideo;

				if(shareVideoID){
					const shareURL = window.location.origin + window.location.pathname + '#video-' + shareVideoID;
					navigator.clipboard.writeText(shareURL).then(function() {
						btn.querySelector('.note').style.opacity = 1;
						setTimeout(() => {
							btn.querySelector('.note').style.opacity = 0;
						}, 2000);
					});	
				}
			});
		});
	}

	function initSliders(){
		sliders.forEach(s => {
			let sliderNavButtons = s.querySelectorAll('.glide-arrow');
			let sliderCounterCurrent = s.querySelector('.counter__current');
			let slideCount = s.querySelectorAll('.glide__slide').length;
			let sliderEl = s.querySelector('.glide');
			let slidesToShow = sliderEl.dataset.slidesToShow || 3;

			let focusAt = slidesToShow == 4 ? 1 : 'center';

			let slider = new Glide(sliderEl, {
				type: 'carousel',
				perView: slidesToShow,
				focusAt: focusAt,
				animationDuration: 400,
				animationTimingFunc: 'ease-in-out',
				breakpoints: {
					1024: {
					  perView: 3,
					  focusAt: 'center',
					},
					500: {
						perView: 1,
						focusAt: 0,
					},
				}
			}).mount();

			sliderEl.classList.remove('glide-no-js');

			const handleSlideEvent = ev => {
				const activeIndex = slider.index;
				const slides = s.querySelectorAll('.glide__slide');
				const activeSlides = s.querySelectorAll('[data-index="'+activeIndex+'"]');
				const beforeIndex = activeIndex == 0 ? slideCount - 1 : activeIndex - 1;
				const afterIndex = activeIndex == slideCount - 1 ? 0 : activeIndex + 1;
				const beforeSlides = s.querySelectorAll('[data-index="'+beforeIndex+'"]');
				const afterSlides = s.querySelectorAll('[data-index="'+afterIndex+'"]');
				const adjacentSlides = Array.from(beforeSlides).concat(Array.from(afterSlides));

				slides.forEach(slide => {
					slide.classList.remove('glide__slide--active', 'glide__slide--adjacent');
				});

				activeSlides.forEach(slide => {
					slide.classList.add('glide__slide--active');
				});

				adjacentSlides.forEach(slide => {
					slide.classList.add('glide__slide--adjacent');
				});

				sliderCounterCurrent.innerText = slider.index + 1;
			};

			slider.on('run', handleSlideEvent);
			handleSlideEvent();

			sliderNavButtons.forEach(btn => {
				btn.addEventListener('click', function (ev) {
					let dir = this.classList.contains('glide-arrow--prev') ? '<' : '>';
					slider.go(dir);
				});
			});
		});
	}

	function initVideoModals(){
		vidyardModalTriggers.forEach(el => {
			const vidyardID = el.dataset.vidyardModal;
			el.onclick = function(e) {
				e.preventDefault();
				openVidyardModal(vidyardID);
			};
			el.onkeydown = function(e) {
				if (e.key === 'Enter' || e.keyCode === 13) {
					e.preventDefault();
					openVidyardModal(vidyardID);
				}
			};
		});
	}

	function openVidyardModal(vidyardID){
		history.pushState(null, null, '#video-'+vidyardID);

		$.magnificPopup.open({
			items: {
				src: `//play.vidyard.com/${vidyardID}.html?autoplay=1`
			},
			type: 'iframe',			
			callbacks: {
				close: function() {
					history.replaceState(null, null, window.location.pathname + window.location.search);
				}
			}
		});
	}

	return {
	init: init,
	};
})();